import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_STATUSES } from "../../../utils/constants";
import { StatusInterface } from "../../../models/TicketModule/Status";
import statusService from "../../../services/ticketService/statusService";

const useStatusById = (id: string) =>
  useQuery<StatusInterface, Error>({
    queryKey: [`${CACHE_KEY_STATUSES}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, statusId] = queryKey;
      return statusService.GetById(statusId as string);
    },
    enabled: !!id,
  });

export default useStatusById;
